import { AppState } from '../../../reducers/index';
import { createSelector } from '@ngrx/store';
import * as fromServiceDeliveryDurationReducer from './service-delivery-duration.reducer';

export const currentState = (state: AppState) => (state[fromServiceDeliveryDurationReducer.serviceDeliveryDurationsFeatureKey]);

export const selectAllServiceDeliveryDurations = createSelector(currentState, fromServiceDeliveryDurationReducer.selectAll);

export const selectTotalServiceDeliveryDurations = createSelector(currentState, fromServiceDeliveryDurationReducer.selectTotal);

export const selectModifiedServiceDeliveryDurations = createSelector(selectAllServiceDeliveryDurations, (serviceDeliveryDurations) => {
  return serviceDeliveryDurations.map((serviceDeliveryDuration) => {
    return {
      ...serviceDeliveryDuration
    };
  });
});

